/* eslint-disable sort-keys */
import {
    AGING_TANK,
    APPELLATION,
    COLOR,
    COUNTRY,
    DECANTATION,
    DRINK_CATEGORY,
    GRAPE_CONTENT,
    MANUFACTURER,
    NET_VOLUME,
    REGION,
    STORAGE_CAPACITY,
    STRONGNESS,
    SUGAR_TYPE,
    TEMPERATURE_FROM,
    TEMPERATURE_TO,
    YEAR,
} from 'modules/product-card/constants/characteristics';

export const HEADER = [COLOR, COUNTRY, REGION, SUGAR_TYPE, GRAPE_CONTENT, MANUFACTURER, STRONGNESS, NET_VOLUME];
export const DETAILED = [
    REGION,
    APPELLATION,
    DRINK_CATEGORY,
    AGING_TANK,
    YEAR,
    STORAGE_CAPACITY,
    DECANTATION,
    TEMPERATURE_FROM,
    TEMPERATURE_TO,
];
export const TABLET = [...HEADER, ...DETAILED];

export const VINO_CHARACTERISTICS = {
    HEADER,
    DETAILED,
    TABLET,
};
